var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.updateStory.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [_vm._v("Project Set Up")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row pad-top-20" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Displaying Device")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    options: _vm.experiences.devices,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    taggable: true,
                    placeholder: "Pick a device"
                  },
                  on: { select: _vm.deviceChanged },
                  model: {
                    value: _vm.experiences.deviceSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "deviceSelected", $$v)
                    },
                    expression: "experiences.deviceSelected"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Device Maker")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    disabled: !_vm.experiences.deviceSelected,
                    options: _vm.experiences.deviceMaker,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    taggable: true,
                    placeholder: "Pick a maker"
                  },
                  model: {
                    value: _vm.experiences.deviceMakerSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "deviceMakerSelected", $$v)
                    },
                    expression: "experiences.deviceMakerSelected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Experience")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    options:
                      _vm.experiences.deviceSelected === "Mobile"
                        ? _vm.experiences.mobileExperienceOptions
                        : _vm.experiences.deviceSelected === "Hands Free"
                        ? _vm.experiences.handsfreeExperienceOptions
                        : _vm.experiences.hmdExperienceOptions,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    taggable: true,
                    disabled: !_vm.experiences.deviceMakerSelected,
                    placeholder: "Pick a experience"
                  },
                  model: {
                    value: _vm.experiences.experienceSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "experienceSelected", $$v)
                    },
                    expression: "experiences.experienceSelected"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Surf Options")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    options: _vm.experiences.surfOptions,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    taggable: true,
                    disabled: !_vm.experiences.experienceSelected,
                    placeholder: "Pick a Surf"
                  },
                  model: {
                    value: _vm.experiences.surfOptionsSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "surfOptionsSelected", $$v)
                    },
                    expression: "experiences.surfOptionsSelected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Camera Options(Only On 'AR')")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.experiences.experienceSelected === "AR",
                      expression: "experiences.experienceSelected === 'AR'"
                    }
                  ],
                  attrs: {
                    options: _vm.experiences.arOptions,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    disabled: !_vm.experiences.surfOptionsSelected,
                    placeholder: "Pick a camera"
                  },
                  model: {
                    value: _vm.experiences.arSelectedOption,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "arSelectedOption", $$v)
                    },
                    expression: "experiences.arSelectedOption"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Final Product")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    options: _vm.experiences.finalProduct,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    taggable: true,
                    multiple: false,
                    disabled:
                      !_vm.experiences.arSelectedOption &&
                      !_vm.experiences.surfOptionsSelected,
                    placeholder: "Pick a product"
                  },
                  model: {
                    value: _vm.experiences.finalProductSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "finalProductSelected", $$v)
                    },
                    expression: "experiences.finalProductSelected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c(
              "div",
              { staticClass: "col-8" },
              [
                _c("label", { staticClass: "typo__label" }, [
                  _vm._v("Choose Industry")
                ]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    options: _vm.experiences.chooseIndustry,
                    searchable: false,
                    "close-on-select": true,
                    "show-labels": false,
                    taggable: true,
                    multiple: true,
                    placeholder: "Industries"
                  },
                  model: {
                    value: _vm.experiences.chooseIndustrySelected,
                    callback: function($$v) {
                      _vm.$set(_vm.experiences, "chooseIndustrySelected", $$v)
                    },
                    expression: "experiences.chooseIndustrySelected"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row pad-top-20" }, [
            _c(
              "div",
              { staticClass: "col-8 flexSpaceBetween text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary text-field-style",
                    attrs: { to: { name: "update-story-step-1" } }
                  },
                  [_vm._v("\n            Previous\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary text-field-style",
                    attrs: {
                      type: "submit",
                      disabled: !(
                        _vm.experiences.finalProductSelected &&
                        _vm.experiences.experienceSelected &&
                        _vm.experiences.finalProductSelected &&
                        _vm.experiences.surfOptionsSelected &&
                        _vm.experiences.deviceSelected &&
                        _vm.experiences.deviceMakerSelected
                      )
                    }
                  },
                  [_vm._v("\n            Next\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a2fe0e9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2fe0e9","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/update_story/step2.vue
// module id = null
// module chunks = 